<script context="module" lang="ts">
export type CardLinkIconImageName =
	| "import_contacts"
	| "currency_yen"
	| "calendar_month"
	| undefined;
</script>

<script lang="ts">
  import { onMount } from "svelte";
  import ArrowForwardSvg from "./icons/arrow-forward-svg.svelte";

  export let href = ''
  export let title: string
  export let description: string | undefined = undefined
  export let border = true
  export let large = false
  export let target: string | undefined = undefined
  export let iconImageName: CardLinkIconImageName = undefined

  let isDesktop = false
  let svgSize = 24

  onMount(() => {
    isDesktop = window.innerWidth > 640
    if (large && isDesktop) {
      svgSize = 32
    }
  })
</script>

<style>
  a:hover {
    color: #4352F5;
    fill: #4352F5;
    outline-color: #4352F5;
    /** hover時は外枠の太さを変えるため、borderではなくoutlineで外枠を表現する */
    border-color: #FFF;
  }

  a:hover div {
    color: #4352F5;
  }

  a:hover p {
    color: #4352F5;
  }
</style>

<a
  href={href}
  target={target}
  data-border={border}
  data-large={large && isDesktop}
  class="block data-[border=true]:border border-solid border-borderGray bg-white p-4 data-[large=true]:py-8 data-[large=true]:px-6 rounded-lg hover:outline hover:outline-2"
>
  {#if iconImageName}
    <div class="w-8 h-8 mb-8 sm:w-14 sm:h-14 sm:mb-8">
      {#if iconImageName === 'import_contacts'}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" width={`${svgSize}px`} height={`${svgSize}px`}><path d="M260-320q47 0 91.5 10.5T440-278v-394q-41-24-87-36t-93-12q-36 0-71.5 7T120-692v396q35-12 69.5-18t70.5-6Zm260 42q44-21 88.5-31.5T700-320q36 0 70.5 6t69.5 18v-396q-33-14-68.5-21t-71.5-7q-47 0-93 12t-87 36v394Zm-40 118q-48-38-104-59t-116-21q-42 0-82.5 11T100-198q-21 11-40.5-1T40-234v-482q0-11 5.5-21T62-752q46-24 96-36t102-12q58 0 113.5 15T480-740q51-30 106.5-45T700-800q52 0 102 12t96 36q11 5 16.5 15t5.5 21v482q0 23-19.5 35t-40.5 1q-37-20-77.5-31T700-240q-60 0-116 21t-104 59ZM280-494Z"/></svg>
      {:else if iconImageName === 'currency_yen'}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" width={`${svgSize}px`} height={`${svgSize}px`}><path d="M440-120v-160H240v-80h200v-80H240v-80h163L200-840h95l185 292 185-292h95L557-520h163v80H520v80h200v80H520v160h-80Z"/></svg>
      {:else if iconImageName === 'calendar_month'}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" width={`${svgSize}px`} height={`${svgSize}px`}><path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z"/></svg>
      {/if}
    </div>
  {/if}
  <div class="flex items-center justify-between">
    <div data-large={large && isDesktop} class="font-bold tracking-wide data-[large=true]:text-xl">
      {title}
    </div>
    <div class="shrink-0">
      <ArrowForwardSvg size={large && isDesktop ? 24 : 16} />
    </div>
  </div>
  {#if description}
    <p data-large={large && isDesktop} class="mt-2 data-[large=true]:mt-4 text-textGray text-sm tracking-wide leading-6">
      {description}
    </p>
  {/if}
</a>